module.exports = __webpack_public_path__ + "static/media/icon-hammer-blue.21c7a6e5.svg";